import { CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID } from '@src/config/env'
import { checkApiBlocked } from '@src/quince-site-common/src/utils/checkApiBlocked'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export const checkIfGtmIsBlocked = () => {
  // HEAD, not GET — the probe only needs the response status to detect an
  // ad-blocker, and googletagmanager.com answers HEAD with 200/no body.
  // Tradeoff: a HEAD can't be served from the container's GET cache entry, so
  // this always costs one round trip, but it never transfers the container body.
  checkApiBlocked(`https://www.googletagmanager.com/gtm.js?id=${CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID}`, {
    method: 'HEAD',
  })
    .then(({ blocked, errorType }) => {
      if (blocked) {
        trackEvent(TELEMETRY_EVENT_NAMES.API_RESPONSE, {
          apiName: 'gtmScript',
          // @i18n-ignore
          status: 'blocked',
          errorType,
        })
      }
    })
    .catch(() => null)
}
